import { getTokenCurrencyByAddr } from "../utils/helpers";
import { iOption, iOptionResponse, iOrder } from "../interfaces/interfaces";
import { cOrder } from "./order";
import { cBigNumber } from "./BigNumber";
import { cStrike } from "./strike";


export class cOption implements iOption{
	optId: number | string;
	fTokenCurrency: string;
	fTokenAddress: string;
	uTokenCurrency: string;
	uTokenAddress: string;
	optionType: boolean; // true => call, false => put
	optionTypeText: 'Put' | 'Call';
	strike: cStrike;
	// create_time: number;
	maturityTime: number;
	period: "daily" | "weekly";
	maturityPrice: cBigNumber;
	ordersBuy: iOrder[];
	ordersSell: iOrder[];


	constructor(responseOption: iOptionResponse){
		this.optId = responseOption.opt_id;

		this.fTokenAddress = responseOption.f_token;
		this.uTokenAddress = responseOption.u_token;


		this.fTokenCurrency = getTokenCurrencyByAddr(responseOption.f_token);
		this.uTokenCurrency =  getTokenCurrencyByAddr(responseOption.u_token);

		this.optionType = responseOption.call_type;
		this.optionTypeText = responseOption.call_type? 'Call' : 'Put';

		this.strike = new cStrike(responseOption.strike.toString());

		// this.create_time = response_option.create_time;
		this.maturityTime = responseOption.maturity_time;

		this.maturityPrice = new cBigNumber(responseOption.maturity_price);

		let buyOrders: iOrder[] = [];
		let sellOrders: iOrder[] = [];
		responseOption.orders && responseOption.orders.forEach(order => {try {
			order.ord_type
				? sellOrders.push(new cOrder(order, this.uTokenCurrency))
				: buyOrders.push(new cOrder(order, this.uTokenCurrency))
		} catch (error) {
			console.warn(error);
		}});
		// sorting (first order - best)
		buyOrders.sort( (a, b) => +b.currentPrice.sub(a.currentPrice).valueStr );
		sellOrders.sort( (a, b) => +a.currentPrice.sub(b.currentPrice).valueStr );

		this.ordersBuy = buyOrders;
		this.ordersSell = sellOrders;

		// period
		/* if (responseOption.maturity_time - responseOption.create_time < 60*60*48){
			this.period = 'daily';
		} else {
			this.period = 'weekly';
		} */
		this.period = 'daily';
	}
}